import { motion } from "framer-motion";

export const EASE = [0.25, 1, 0.5, 1];

export const MaskedLine = ({ children, delay = 0, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <span className={`block overflow-hidden ${className}`}>
      <Tag
        initial={{ y: "110%", rotate: 2 }}
        animate={{ y: "0%", rotate: 0 }}
        transition={{ duration: 1, delay, ease: EASE }}
        style={{ display: "block", willChange: "transform" }}
      >
        {children}
      </Tag>
    </span>
  );
};

export const ScrollReveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, title }) => (
  <div className="flex items-center gap-4 mb-6">
    <span className="font-mono2 text-xs tracking-[0.3em] text-[#F2F0EB]">{index}</span>
    <span className="h-px w-10 bg-[#F2F0EB]/40" />
    <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#8A8A85]">{title}</span>
  </div>
);
